import { BordOneToneIcon } from 'components/NudosComponents';
import { formatShortDate } from 'utils/formatDatesAndHours';
import { BordTooltip } from 'bord-design-system';
import { Link } from 'react-router-dom';

import './QuoteOrdersList.scss';

interface IQuoteOrdersList {
  ids: number[];
  orderDate?: string;
}

export const QuoteOrdersList = ({ ids = [], orderDate }: IQuoteOrdersList) => {
  if (!ids.length) return <span>-</span>;

  if (ids.length === 1)
    return (
      <div className="quoteOrdersList center">
        {formatShortDate(orderDate)?.onlyDate}
        <Link className="quoteOrder" target="_blank" to={`/order/details/${ids[0]}`}>
          Orden N°{ids[0]} <BordOneToneIcon variant="externalLink" className="icon" customWidth="1.2rem" />
        </Link>
      </div>
    );
  return (
    <div className="quoteOrdersList center">
      <span>{`Total: ${ids?.length ?? 0}`}</span>
      <BordTooltip
        position="bottom"
        customClassNameMessageContainer="quoteOrdersListTooltip"
        messageContainerSize={{ minWidth: 'fit-content' }}
        message={
          <div className="contentOrdersList">
            {ids?.map(id => (
              <Link to={`/order/details/${id}`} target="_blank" className="quoteOrder underline" key={id}>
                Orden N°{id}
              </Link>
            ))}
          </div>
        }
      >
        <div className="quoteOrder">
          Órdenes <BordOneToneIcon variant="arrowHeadDown" className="icon" customWidth="1.2rem" />
        </div>
      </BordTooltip>
    </div>
  );
};
